import type {
  CommonSuccess,
  Order,
  OrderCreateRequest,
  OrderDetail,
  PayOrder,
} from '@/shared/api/service';
import { OrderService } from '@/shared/api/service';

export class OrderApi {
  static async create(payload: OrderCreateRequest): Promise<PayOrder> {
    return OrderService.v1OrdersCreate({ body: payload });
  }

  static async get(orderId: number): Promise<Order> {
    return OrderService.v1OrdersRetrieve({ orderId });
  }

  static async getDetail(orderId: number): Promise<OrderDetail> {
    return OrderService.v1OrderDetailRetrieve({ orderId });
  }

  static async confirmPayment(orderId: number): Promise<CommonSuccess> {
    return OrderService.confirmOrderPaymentCreate({ orderId });
  }

  static async failPayment(orderId: number): Promise<CommonSuccess> {
    return OrderService.failedOrderPaymentCreate({ orderId });
  }

  static async listUserOrders(): Promise<OrderDetail[]> {
    return OrderService.v1OrdersUserList();
  }
}
